import { Container } from "../NoDataList/NoDataList.styles"

export const NoParticipation = () => {
  return (
    <Container className="background">
      <h1>No Participation</h1>
      <p>This physician does not take part in any of DoveMed's products.</p>
    </Container>
  )
}
